const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

export default function TrendIcon({ size = 40, withCircle = true, fill = "#1A1A1A" }) {
  const viewBox = withCircle ? "0 0 80 80" : "0 0 15 15";
  const iconTransform = withCircle ? "translate(20 20) scale(2.66)" : "";

  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withCircle && <CirclePath color={fill} />}
      <g transform={iconTransform}>
        <path
          d="M0.371048 1.50247C0.156298 1.52603 -0.00478535 1.70966 0.000108588 1.92497V13.1571C0.000108588 13.3871 0.186397 13.5731 0.416614 13.5731H14.5778C14.6892 13.5748 14.7966 13.5317 14.8763 13.4537C14.9553 13.3749 15 13.2684 15 13.1571C15 13.0458 14.9553 12.9394 14.8763 12.8605C14.7966 12.7825 14.6892 12.7395 14.5778 12.7411H0.833119V1.92496C0.83556 1.80552 0.78675 1.69014 0.69808 1.6089C0.60941 1.52846 0.490629 1.48947 0.371048 1.50247ZM11.2066 4.62896C11.096 4.63384 10.9919 4.68259 10.9179 4.76465C10.843 4.8459 10.8048 4.95397 10.8097 5.06447C10.8145 5.17497 10.8634 5.27896 10.9455 5.3529C11.0269 5.42766 11.1351 5.46584 11.2457 5.46097H13.3282V7.541C13.3266 7.65231 13.3697 7.75957 13.4478 7.83919C13.5267 7.918 13.6333 7.96269 13.7447 7.96269C13.8562 7.96269 13.9628 7.918 14.0417 7.83919C14.1198 7.75956 14.1629 7.65231 14.1612 7.541V5.04496C14.1612 4.81501 13.975 4.62896 13.7447 4.62896H11.2457C11.2327 4.62814 11.2197 4.62815 11.2066 4.62896ZM12.1828 6.08498C12.0746 6.08254 11.9697 6.12236 11.89 6.19548L8.94841 8.85397L6.10452 6.39038C5.94507 6.25226 5.70754 6.25469 5.55136 6.39688L1.80281 9.72493C1.72064 9.79887 1.67102 9.90287 1.66451 10.0134C1.65882 10.1239 1.69787 10.2319 1.77189 10.314C1.84674 10.3969 1.95086 10.4456 2.06149 10.4505C2.17212 10.4562 2.28032 10.4172 2.36248 10.3424L5.83113 7.26149L8.6817 9.72508C8.84114 9.86321 9.07867 9.86077 9.23486 9.71858L12.4499 6.81299C12.5784 6.69923 12.6248 6.51885 12.5654 6.35798C12.5068 6.1971 12.3547 6.08822 12.183 6.08498L12.1828 6.08498Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}
